/* eslint-disable no-console */
import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import Box from 'ui-box';
import * as Yup from 'yup';
import { Button, Select, Input, Form } from 'antd';
import LoadingSpinner from '../../common/LoadingSpinner';
import { errorNotification } from '../../../utils/notification-helpers';

const heights = [
  {label: 'cm', value: 'cm'},
  {label: 'ft', value: 'ft'},
  {label: 'inch', value: 'inch'},
];

const weights = [
  {label: 'kg', value: 'kg'},
  {label: 'g', value: 'g'},
  {label: 'lbs', value: 'lbs'},
];

function MeasurementsForm({ onSubmitBtnText, onSubmitForm, dataMedicalHistory }) {
  const { t } = useTranslation(['common', 'medical-history']);
  const fieldName = "measurements"
  const defaultValueHeight = "cm"
  const defaultValueWeight = "kg"

  const FormSchema = useMemo(
    () =>
      Yup.object().shape({
        measurements: Yup.string().required(t('form.error.required'))
      }),
    [t]
  );

  const initialValues = {
    measurements: dataMedicalHistory && dataMedicalHistory.measurements ? dataMedicalHistory.measurements : null,
  };

  const handleChangeHeight = (e, values, setFieldValue) => {
    const data = {...values[fieldName]}
    const height = {
      number: e.target.value,
      type: data?.height?.type ?? defaultValueHeight
    }
    data.height = height
    setFieldValue(fieldName, data)
  }

  const handleChangeHeightType = (value, values, setFieldValue) => {
    const data = {...values[fieldName]}
    const height = {
      number: data?.height?.number ?? null,
      type: value
    }
    data.height = height
    setFieldValue(fieldName, data)
  }

  const handleChangeWeight = (e, values, setFieldValue) => {
    const data = {...values[fieldName]}
    const weight = {
      number: e.target.value,
      type: data?.weight?.type ?? defaultValueWeight
    }
    data.weight = weight
    setFieldValue(fieldName, data)
  }

  const handleChangeWeightType = (value, values, setFieldValue) => {
    const data = {...values[fieldName]}
    const weight = {
      number: data?.weight?.number ?? null,
      type: value
    }
    data.weight = weight
    setFieldValue(fieldName, data)
  }

  return (
    <div style={{ width: '100%', textAlign: 'left' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={FormSchema}
        onSubmit={async (values) => {
          const dataForm = dataMedicalHistory ?? {};
          dataForm.measurements = values.measurements
          console.log("dataForm", dataForm)
          onSubmitForm(dataForm)
        }}
      >
        {({ isSubmitting, isValid, values, setFieldValue }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting}>
                <Form.Item
                  name={["height", "number"]}
                  label={t('medical-history:measurements.form.height.label')}
                >
                  <Input
                    style={{ width: '100%' }}
                    onChange={(e) => handleChangeHeight(e, values, setFieldValue)}
                    defaultValue={values[fieldName]?.height?.number}
                    value={values[fieldName]?.height?.number}
                    addonAfter={
                      <Form.Item
                        name={["height", "type"]}
                        noStyle
                      >
                        <Select
                          defaultValue={values[fieldName]?.height?.type ?? defaultValueHeight}
                          value={values[fieldName]?.height?.type}
                          options={heights}
                          onChange={(value) => handleChangeHeightType(value, values, setFieldValue)} />
                      </Form.Item>
                    }
                  />
                </Form.Item>
                <Form.Item
                  name={["weight", "number"]}
                  label={t('medical-history:measurements.form.weight.label')}
                >
                  <Input
                    style={{ width: '100%' }}
                    onChange={(e) => handleChangeWeight(e, values, setFieldValue)}
                    defaultValue={values[fieldName]?.weight?.number}
                    value={values[fieldName]?.weight?.number}
                    addonAfter={
                      <Form.Item
                        name={["weight", "type"]}
                        noStyle
                      >
                        <Select
                          defaultValue={values[fieldName]?.weight?.type ?? defaultValueWeight}
                          value={values[fieldName]?.weight?.type}
                          options={weights}
                          onChange={(value) => handleChangeWeightType(value, values, setFieldValue)}
                        />
                      </Form.Item>
                    }
                  />
                </Form.Item>
                <Box paddingTop={15}>
                  <Button
                    disabled={isSubmitting || !isValid}
                    loading={isSubmitting}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                  >
                    {isSubmitting ? <LoadingSpinner position="full" transparent={false} /> : onSubmitBtnText}
                  </Button>
                </Box>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

MeasurementsForm.defaultProps = {
  onSubmitBtnText: 'Save & Update'
};

const { string, func } = PropTypes;

MeasurementsForm.propTypes = {
  onSubmitBtnText: string,
  onSubmitForm: func.isRequired,
  dataMedicalHistory: PropTypes.objectOf(PropTypes.any).isRequired
};

export default MeasurementsForm;
